<template>
  <div>
    <div class="alert alert-danger" v-if="errorMsg">{{ errorMsg }}</div>

    <div class="row mb-2">
      <div class="col-auto">
        <button class="btn btn-primary gdq_faded gdq-font-size-80" @click="addNew">
          <span class="icon-plus mr-1"></span>Add session
        </button>
      </div>
    </div>

    <div class="card mb-3" v-if="showForm">
      <div class="card-body">
        <h6 class="card-title">{{ editing.id > 0 ? 'Edit session' : 'New session' }}</h6>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Title</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.title" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Day label</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.day_label" placeholder="15 Oct" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Month label</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.month_label" placeholder="October" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Time</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.time_text" placeholder="09.00–16.00 CET" /></div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Location</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.location_text" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Start</label>
              <div style="width: 67%"><input class="form-control" type="datetime-local" v-model="editing.start_dt_local" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">End</label>
              <div style="width: 67%"><input class="form-control" type="datetime-local" v-model="editing.end_dt_local" /></div>
            </div>
          </div>
        </div>
        <div>
          <button class="btn btn-outline-secondary" @click="cancel">Cancel</button>
          <button class="btn btn-primary float-end" :disabled="saving" @click="save">
            <fa-icon name="check" />Save
          </button>
        </div>
      </div>
    </div>

    <table class="table table-hover lh-table">
      <thead>
        <tr>
          <th style="width: 40px;">#</th>
          <th>Title</th>
          <th>Day</th>
          <th>Time</th>
          <th>Start</th>
          <th>Location</th>
          <th style="width: 110px;">⚡</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in rows" :key="item.id" style="cursor: pointer;" @click="editRow(item)">
          <td>{{ item.sort }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.day_label || '-' }}</td>
          <td>{{ item.time_text || '-' }}</td>
          <td>{{ fmtDt(item.start_dt) }}</td>
          <td>{{ item.location_text || '-' }}</td>
          <td>
            <span class="me-2" style="cursor: pointer;" title="Move up" v-if="i > 0" @click.prevent.stop="move(item, i, -1)">
              <fa-icon name="arrow-up" />
            </span>
            <span class="me-2" style="cursor: pointer;" title="Move down" v-if="i < rows.length - 1" @click.prevent.stop="move(item, i, 1)">
              <fa-icon name="arrow-down" />
            </span>
            <span style="cursor: pointer;" title="Delete" @click.prevent.stop="delRow(item)">
              <fa-icon name="trash-alt" />
            </span>
          </td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="7" class="text-center text-muted py-3">No sessions</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'LHCourseSessions',
  props: {
    courseId: { type: Number, required: true },
    rows: { type: Array, required: true }
  },
  data () {
    return {
      showForm: false,
      saving: false,
      errorMsg: '',
      editing: this.emptyRow()
    }
  },
  methods: {
    emptyRow () {
      return {
        id: 0, sort: 0, title: '', day_label: '', month_label: '',
        time_text: '', location_text: '', start_dt_local: '', end_dt_local: ''
      }
    },
    addNew () {
      this.errorMsg = ''
      this.editing = this.emptyRow()
      this.editing.sort = this.rows.length + 1
      this.showForm = true
    },
    editRow (r) {
      this.errorMsg = ''
      this.editing = { ...r, start_dt_local: this.toLocal(r.start_dt), end_dt_local: this.toLocal(r.end_dt) }
      this.showForm = true
    },
    cancel () {
      this.showForm = false
    },
    toLocal (s) {
      return s ? String(s).replace(' ', 'T').substring(0, 16) : ''
    },
    fromLocal (s) {
      if (!s) return null
      return s.includes(':') ? s.replace('T', ' ') + (s.length === 16 ? ':00' : '') : s
    },
    fmtDt (s) {
      return s ? String(s).substring(0, 16).replace('T', ' ') : '-'
    },
    buildBody () {
      return {
        course_id: this.courseId,
        sort: this.editing.sort,
        title: this.editing.title,
        day_label: this.editing.day_label,
        month_label: this.editing.month_label,
        time_text: this.editing.time_text,
        location_text: this.editing.location_text,
        start_dt: this.fromLocal(this.editing.start_dt_local),
        end_dt: this.fromLocal(this.editing.end_dt_local)
      }
    },
    async save () {
      this.saving = true
      this.errorMsg = ''
      try {
        const body = this.buildBody()
        if (this.editing.id > 0) {
          delete body.course_id
          await this.$store.dispatch('learninghub_session_update', { id: this.editing.id, body })
        } else {
          await this.$store.dispatch('learninghub_session_save', { body })
        }
        this.showForm = false
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Save failed')
      }
      this.saving = false
    },
    async delRow (r) {
      if (!confirm('Delete session "' + r.title + '"?')) return
      try {
        await this.$store.dispatch('learninghub_session_delete', { id: r.id })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Delete failed')
      }
    },
    async move (item, i, dir) {
      const ids = this.rows.map(x => x.id)
      const j = i + dir
      ;[ids[i], ids[j]] = [ids[j], ids[i]]
      try {
        await this.$store.dispatch('learninghub_reorder', { body: { entity: 'session', ids } })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.message || 'Reorder failed'
      }
    }
  }
}
</script>

<style>
.lh-table {
  font-size: 0.9rem !important;
}
</style>
